<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        outlined
        color="error"
        class="mr-3"
      >
        <v-icon>mdi-cancel</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="modal-header elevation-10"
      >
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h2>Confirma que deseja interromper a solução?</h2>
          </v-col>
        </v-row>

        <v-row>
          <v-col>{{ solution.nome }}</v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Justificativa"
              v-model="solution.justificativa"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false">Cancelar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Confirmar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { citySolutionAPI } from '@/modules/city/API/CitySolutionAPI'
import { mapActions } from 'vuex'

export default {
  name: 'AppModalConfirmStopSolution',
  props: {
    solution: { type: Object, required: true }
  },
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    onConfirm () {
      this.setLoading(true)
      this.solution.concluida = false
      this.solution.interrompida = true
      citySolutionAPI.update(this.solution)
        .then(resp => {
          this.dialog = false
          this.$emit('onCloseModal')
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao atualizar solução')
        })
    }
  }
}
</script>
